// extracted by mini-css-extract-plugin
export var clickThrough = "_yp-2";
export var fallback = "_yp-5";
export var frame = "_yp-3";
export var frameCell = "_yp-1";
export var overlay = "_yp-4";
export var wrapper = "_yp-0";